// extracted by mini-css-extract-plugin
export default {"selectWrapper":"SelectBasic_selectWrapper__6cfAj"};